import { useQuery } from '@apollo/client';

import { graphql } from '@eluve/graphql.tada';

import { useAppointmentContext } from './appointment.context';

const getIsSummarizedQuery = graphql(`
  query getIsSummarized($tenantId: uuid!, $appointmentId: uuid!) {
    appointmentsByPk(tenantId: $tenantId, id: $appointmentId) {
      __typename
      id
      humanOutputs(
        where: { output: { outputType: { _eq: SOAP_NOTE } } }
        limit: 1
      ) {
        __typename
        humanOutputId
      }
    }
  }
`);

/**
 * Checks if an appointment has a summary.
 *
 * Skips the query when tenantId or appointmentId is not available.
 *
 * @returns boolean - true if the appointment has at least one human output with SOAP_NOTE type
 */
export const useIsSummarized = (): boolean => {
  const { tenantId, appointmentId } = useAppointmentContext();

  const { data } = useQuery(getIsSummarizedQuery, {
    variables: {
      tenantId,
      appointmentId,
    },
    skip: !appointmentId || !tenantId,
  });

  return Boolean(data?.appointmentsByPk?.humanOutputs?.length);
};
